import { translation } from "@/configurations/i18n"
import { TFunction } from "i18next"

const dateFormat = "DD:MM:YYY"

const LANGUAGES = {
  ko: "ko",
  en: "en"
} as const
const KR_COUNTRY_CODE = "kr"

const STORAGE_KEYS = {
  I18NEXTLNG: "i18nextLng"
}
export const IMAGE_BASE_URL = `${import.meta.env.VITE_BACKEND_URL}/`

export { dateFormat, KR_COUNTRY_CODE, LANGUAGES, STORAGE_KEYS }

export const DIFFICULTIES = (
  t: TFunction<"translation", undefined>
): { [key: string]: string } => {
  return {
    "사전지식 불필요 : 튜토리얼이나 개요 수준에서의 설명": t(
      translation.session.difficulty.easy
    ),
    "기본적인 사전 지식 필요": t(translation.session.difficulty.medium),
    "관련 실무 경험 필요": t(translation.session.difficulty.hard)
  }
}
